import React from "react";

import { Grid } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

export default function Search({
  value,
  onChange,
  placeholder = "Search",
  ...otherProps
}) {
  return (
    <Paper {...otherProps}>
      <Grid container alignItems="center">
        <IconButton>
          <SearchIcon />
        </IconButton>
        <Grid item xs>
          <InputBase
            style={{ paddingRight: 15 }}
            fullWidth
            type="search"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            // inputProps={{ "aria-label": "search" }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}
